import type { ReactElement } from "react"

import { Typography } from "@synapse-analytics/synapse-ui"

import styles from "./Divider.module.scss"

type DividerProps = {
  text?: string
  mt?: number
  mb?: number
}

/**
 * A horizontal divider line component that optionally displays text in its center.
 * Used to visually separate content sections in the UI.
 *
 * @param {string} [text] - Optional text to display in the center of the divider
 * @param {number} [mt] - Optional top margin for the divider -> value is multiplied by 8px
 * @param {number} [my] - Optional vertical margin for the divider -> value is multiplied by 8px
 * @returns {ReactElement} A divider element with optional centered text
 */
export function Divider(props: Readonly<DividerProps>): ReactElement {
  const { text, mt = 0, mb = 0 } = props

  return (
    <div className={styles.line} style={{ marginTop: `${mt * 8}px`, marginBottom: `${mb * 8}px` }}>
      {!!text && (
        <Typography variant="a" className={styles.text}>
          {text}
        </Typography>
      )}
    </div>
  )
}
